export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, JSON.stringify(value))
}

export const getLocalStorage = (name) => {
  if (name === 'ERROR_LOGIN_MSG') {
    if (localStorage.getItem(name) === 'undefined') {
      localStorage.removeItem(name)
      return null
    }
  }
  return JSON.parse(localStorage.getItem(name))
}

export const removeLocalStorage = (name) => {
  localStorage.removeItem(name)
}

export const clearLocalStorage = () => {
  localStorage.clear()
}